import React, { FC, memo } from 'react';

import { DATA_TEST_IDS } from '../../consts';
import { TEXTS } from '../../texts';
import ReportSelectTrigger from '../../ReportSelectTrigger';

const promoTriggerLabelledBy = [
  DATA_TEST_IDS.AUDIO_REPORT_PROMOS_LABEL,
  DATA_TEST_IDS.AUDIO_REPORT_PROMOS_TRIGGER_TITLE,
  DATA_TEST_IDS.AUDIO_REPORT_PROMOS_TRIGGER_COUNT,
].join(' ');

type PromoSelectTriggerProps = {
  dropdownId: string;
  isOpen: boolean;
  selectedCount: number;
  totalCount: number;
  onClick: () => void;
};

const PromoSelectTrigger: FC<PromoSelectTriggerProps> = ({
  dropdownId,
  isOpen,
  selectedCount,
  totalCount,
  onClick,
}) => (
  <ReportSelectTrigger
    ariaLabelledBy={promoTriggerLabelledBy}
    count={`(${selectedCount}/${totalCount})`}
    countTestId={DATA_TEST_IDS.AUDIO_REPORT_PROMOS_TRIGGER_COUNT}
    dropdownId={dropdownId}
    elementId={DATA_TEST_IDS.AUDIO_REPORT_PROMOS_TRIGGER}
    isOpen={isOpen}
    testId={DATA_TEST_IDS.AUDIO_REPORT_PROMOS_TRIGGER}
    title={TEXTS.AUDIO_REPORT_PROMOS_SELECTED_TITLE}
    titleTestId={DATA_TEST_IDS.AUDIO_REPORT_PROMOS_TRIGGER_TITLE}
    onClick={onClick}
  />
);

export default memo(PromoSelectTrigger);
